import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMightyFormsRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#272E58",
		d: "M14.9 3.2h2.5l2.3.5a13 13 0 0 1 8.9 9.9l.2 1.3v2.2l-.2 1q0 .8-.3 1.4a13 13 0 0 1-9.6 9l-1.5.3h-2.4l-1.4-.2q-1.5-.4-3-1.1a13 13 0 0 1-7-9.3L3.2 17v-2.6q.3-1.6.9-3.2 2.3-5.5 8-7.5l1.4-.4z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#FEFEFE",
		d: "M19 9.6h3.3l-2 2.5-3.5 4.4-.8 1h-.3l-1.2-1.2-2.2-2.2v8H9.6V9.5h3l.8 1 2.4 2.6 2.3-2.6zm1 7.2q1 .6 2.3 0V22h-2.4zm1-3.5a1.2 1.2 0 1 1 .3 2.4 1.2 1.2 0 0 1-.4-2.4"
	})]
});
export default SvgMightyFormsRegularIcon;
